import React from 'react'
import { Bleedable } from '@fs/zion-ui'
import useIsMobile from '../hooks/useIsMobile'

export default function ContentContainer({ children }) {
  const isMobile = useIsMobile()
  const pad = isMobile ? 32 : 80
  return <Bleedable sides={pad}>{children}</Bleedable>
}
